var React = require('react');

function IconMessages (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#4D4540","clipPath":"url(#a)","key":0},[React.createElement("path",{"d":"m11.753 5.396-5.328 2.64-.944-1.905L10.81 3.49a1.064 1.064 0 0 1 .943 1.906ZM11.753 11.566l-5.328-2.64-.944 1.906 5.329 2.64a1.064 1.064 0 0 0 .943-1.905Z","key":0}),React.createElement("path",{"d":"M17 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM17 13.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM7 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h17v17H0z"})))]);
}

IconMessages.defaultProps = {"fill":"none","viewBox":"0 0 17 17"};

module.exports = IconMessages;

IconMessages.default = IconMessages;
